<!-- TODO: 
 
Create a barrel file for common components:
Then you can import multiple components in one line:
This gives you the benefits of cleaner imports while maintaining explicit dependencies and all the advantages mentioned above.
index.ts
export { default as Link } from './Link.svelte';
export { default as Button } from './Button.svelte';
// ... other common components

Then you can import multiple components in one line:
import { Link, Button } from '$lib/components/common';
 -->

<script lang="ts">
	export let href: string;
	export let external = false;
	export let variant: 'base' | 'blue700' = 'base';
	export let className = '';
</script>

<a
	{href}
	class={`underline cursor-pointer transition-all brightness-110 hover:brightness-125 hover:underline ${
		variant === 'base' ? 'text-bloomBlueNormal' : 'text-blue-700'
	} ${className}`}
	target={external ? '_blank' : undefined}
	rel={external ? 'noopener noreferrer' : undefined}
>
	<slot />
</a>
